export default {
  inforOrder: {},
  orderNo: '',
  inforMerchant: {}
}
